module.exports = __webpack_public_path__ + "static/media/brochure-cover-graphic.338112ad.webp";